import React from 'react';

export default function NotFound() {
    return (
        <div>
            <div className="inset-center text-gray-500">Page not found</div>
        </div>
    );
};
